import formModule from '@/store/modules/form-module';
import insuredEventClaimModule from '@/store/modules/insurances/insured-event-claim-module';
import lifeAndHealthInsuranceModule from '@/store/modules/insurances/life-and-health-insurance-module';
import contractInfoInsurerModule from '@/store/modules/insurances/shared/contract-info-insurer-module';
import contractInfoApplicantModule from '@/store/modules/insurances/shared/contract-info-applicant-module';
import propertyDamageModule from '@/store/modules/insurances/property-damage-module';
import mortgageTitleInsuranceModule from '@/store/modules/insurances/mortgage-title-insurance-module';
import gapInsuranceModule from '@/store/modules/insurances/gap-insurance-module';
import personalProtectionModule from '@/store/modules/insurances/personal-protection-module';
import premierInvestModule from '@/store/modules/insurances/premier-invest/premier-invest-module';
import deathSelectModule from '@/store/modules/insurances/premier-invest/childs/death-select-module';
import premierLifeModule from '@/store/modules/insurances/premier-life/premier-life-module';
import purchaseProtectionModule from '@/store/modules/insurances/purchase-protection-module';
import bankCardProtectionModule from '@/store/modules/insurances/bank-card-protection-module';
import maximumProtectionModule from '@/store/modules/insurances/maximum-protection/maximum-protection-module';
import anticrisisModule from '@/store/modules/insurances/anticrisis/anticrisis-module';
import barrierModule from '@/store/modules/insurances/barrier-module';
import houseModule from '@/store/modules/insurances/house-module';
import personsSharedModule from '@/store/modules/insurances/persons-shared-module';
import sharedDataModule from '@/store/modules/insurances/shared-data-module';
import contractInfoSharedModule from '@/store/modules/insurances/contract-info-shared-module';
import personalDataFormModule from '@/store/modules/personal-data-form-module';
import homeModule from '@/store/modules/home-module';
import premierInsuranceModule from '@/store/modules/insurances/shared/premier-insurance-module';

export default {
    formModule,
    insuredEventClaimModule,
    lifeAndHealthInsuranceModule,
    contractInfoInsurerModule,
    contractInfoApplicantModule,
    propertyDamageModule,
    mortgageTitleInsuranceModule,
    gapInsuranceModule,
    personalProtectionModule,
    premierInvestModule,
    deathSelectModule,
    premierLifeModule,
    purchaseProtectionModule,
    bankCardProtectionModule,
    maximumProtectionModule,
    anticrisisModule,
    barrierModule,
    houseModule,
    personsSharedModule,
    sharedDataModule,
    contractInfoSharedModule,
    personalDataFormModule,
    homeModule,
    premierInsuranceModule,
} // export.